import React, { useState } from "react";
import { postSummarypromptData, postSummarylength } from "../../../services/AdminService";
import { Form } from "react-bootstrap";
import ModalComponent from "../../../components/ModalComponent";
import { toast } from "react-toastify";

const NewSummaryPrompt = ({ type, ...props }) => {
    const [formData, setFormData] = useState({
        document_type: "",
        length_type: "",
        instruction_text: ""
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleCreateSubmit = async () => {
        setLoading(true);

        if (!formData.instruction_text.trim()) {
            toast.error("Instruction text cannot be empty.");
            setLoading(false);
            return;
        }

        const isDuplicate = props.currentData.some(
            (item) =>
                (type === "document" ? item.document_type : item.length_type) ===
                (type === "document" ? formData.document_type : formData.length_type)
        );

        if (isDuplicate) {
            toast.error(`A summary with this ${type} type already exists.`);
            setLoading(false);
            return;
        }

        try {
            const payload =
                type === "document"
                    ? {
                          document_type: formData.document_type,
                          instruction_text: formData.instruction_text
                      }
                    : {
                          length_type: formData.length_type,
                          instruction_text: formData.instruction_text
                      };

            await (type === "document"
                ? postSummarypromptData(payload)
                : postSummarylength(payload));

            toast.success("Summary created successfully!");
            props.fetchSummaryData();

            setFormData({
                document_type: "",
                length_type: "",
                instruction_text: ""
            });

            props.handleClose();
        } catch (err) {
            toast.error("Failed to create summary.");
        } finally {
            setLoading(false);
        }
    };

    const footerButtons = [
        {
            label: "Cancel",
            variant: "outline-secondary",
            onClick: props.handleClose
        },
        {
            label: loading ? "Saving..." : "Save",
            variant: "primary",
            onClick: handleCreateSubmit,
            disabled: loading
        }
    ];

    return (
        <ModalComponent
            show={props.show}
            handleClose={props.handleClose}
            title={`Add ${
                type === "document" ? "Document" : "Length"
            } Summary Prompt`}
            footerButtons={footerButtons}
            size="md"
        >
            <Form>
                <Form.Group className="mb-1">
                    <Form.Label className="fw-bolder text-dark mb-1">
                        {type === "document" ? "Document Type" : "Length Type"}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        name={type === "document" ? "document_type" : "length_type"}
                        value={
                            type === "document"
                                ? formData.document_type
                                : formData.length_type
                        }
                        onChange={handleChange}
                        placeholder={`Enter ${
                            type === "document" ? "document" : "length"
                        } type`}
                        className="border-black mb-3"
                        required
                    />
                </Form.Group>

                <Form.Group className="mb-1">
                    <Form.Label className="fw-bolder text-dark mb-1">
                        Prompt Instruction
                    </Form.Label>
                    <Form.Control
                        as="textarea"
                        name="instruction_text"
                        value={formData.instruction_text}
                        onChange={handleChange}
                        placeholder="Enter instructions"
                        rows={4}
                        required
                        className="border-black"
                        style={{ height: "180px", resize: "none" }}
                    />
                </Form.Group>
            </Form>
        </ModalComponent>
    );
};

export default NewSummaryPrompt;
